/**
 * ChannelRulesDialog – Modal wrapper für den ChannelRulesBuilder
 *
 * Öffnet den Variante-A-Builder in einem fullscreen-breiten Dialog.
 * Wird vom Einstiegspunkt in MergedProductsPage gesteuert.
 */

import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/v2/ui/Dialog'
import { ChannelRulesBuilder } from './ChannelRulesBuilder'

interface ChannelRulesDialogProps {
  open: boolean
  onClose: () => void
}

export function ChannelRulesDialog({ open, onClose }: ChannelRulesDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose() }}>
      <DialogContent className="max-w-5xl w-full">
        <DialogHeader>
          <DialogTitle>{t('channelRules.title')}</DialogTitle>
        </DialogHeader>
        <div className="mt-4 min-h-[400px]">
          <ChannelRulesBuilder />
        </div>
      </DialogContent>
    </Dialog>
  )
}
